import { message } from "antd";
import axios from "axios";
import { AxiosConfig, AxiosConfigWithAdminToken } from "Admin/Config/AxiosConfig";

export const getUserInfo = (callback) => {
  const axios = AxiosConfig();
  let url = `/user/about_me`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => getUserInfo(callback));
      } else {
        callback(err.response.data);
      }
    });
};
export const exchangeToken = (callback) => {
  const axios = AxiosConfigWithAdminToken();
  let url = `/auth/exchange_token`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      callback(err.response.data);
    });
};
export const refreshToken = (callback) => {
  const token = localStorage.getItem(
    `${process.env.REACT_APP_PREFIX}_refresh_token`
  );
  const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  let url = `/auth/refresh`;
  instance
    .get(url)
    .then((res) => {
      localStorage.setItem(
        `${process.env.REACT_APP_PREFIX}_access_token`,
        res.data.access_token
      );
      callback();
    })
    .catch((err) => {
      localStorage.removeItem(`${process.env.REACT_APP_PREFIX}_admin_access_token`);
      localStorage.removeItem(`${process.env.REACT_APP_PREFIX}_admin_refresh_token`);
      localStorage.removeItem(`${process.env.REACT_APP_PREFIX}_access_token`);
      localStorage.removeItem(`${process.env.REACT_APP_PREFIX}_refresh_token`)
    });
};

export const loginSAML = () => {
  // const axios = AxiosConfigAdmin();
  // let url = `/auth/saml/login`;
  const currentUrl = `${window.location.origin}${window.location.pathname}`;
  window.location.href = `${
    process.env.REACT_APP_API_BASE_URL_ADMIN
  }/v2/auth/saml/login?origin=${encodeURIComponent(currentUrl)}&source=explore`;
};
export const confirmSAML = (payload) => {
  const axios = AxiosConfig();
  let url = `/admin/auth/saml/callback`;
  return axios.post(url, payload);
};
